// When we recreate objects the JSON serialisation of the properties may differ
// For our like-for-like testing this is critical - so for testing, sort the proprties!
export function serialiseJsonSorted(obj: any): string {
  return JSON.stringify(obj, Object.keys(obj).sort());
}
